module.exports = __webpack_public_path__ + "img/old.be5030ca.webp";